<style lang="less" scoped>
  @import "../../vars.less";

  .gesture-set {
    background-color: #fff;
  }
  .container {
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .header {
    position: relative;
    z-index: 1;
  }
  .welcome {
    margin: @space-large * 2 0 0 0;
    font-size: 16px;
    text-align: center;
    color: @text-color;
  }
  .placeholder {
    margin: @space-small 0 0 0;
    text-align: center;
    font-size: 14px;
    color: @text-color-secondary;
    &.danger {
      color: @danger-color;
    }
  }
  .gesture-password-container {
    flex: none;
    position: relative;
    top: -20px;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .tips {
    padding: @space-normal;
  }
</style>

<template>
  <page-container class="gesture-set">
    <div class="container">
      <div class="header">
        <h3 class="welcome">{{ $t('设置手势密码') }}</h3>
        <p class="placeholder" v-show="index === 0">{{ $t('请输入手势密码') }}</p>
        <p class="placeholder" v-show="index === 1">{{ $t('请再次输入手势密码') }}</p>
        <p class="placeholder danger" v-show="index === 0 && !samePwds">{{ $t('两次输入的手势密码不一致，请重新输入') }}</p>
      </div>
      <div class="gesture-password-container" @touchmove.stop.prevent>
        <gesture-password :width="width" :height="width"
          lineColor="#009999"
          lineBackground="#9aecec"
          @onChange="onChange"></gesture-password>
      </div>
    </div>
    <div class="tips" slot="footer">
      <div class="btn-container"></div>
      <van-button round block plain @click="disableTips">
        {{ $t('不再提示' )}}
      </van-button>
    </div>
  </page-container>
</template>

<script>
import { Button, Toast, Notify } from 'vant'
import GesturePassword from '@alitajs/gesture-password-vue'
import PageContainer from '../../components/PageContainer'
import { LS_KEYS } from '../../constants'
import { encrypt } from '../../utils/crypto'
import ls from '../../utils/local-storage'

export default {
  name: 'gesture-set',
  components: {
    GesturePassword,
    PageContainer,
    'van-button': Button
  },
  data () {
    return {
      width: 1000,
      limit: 5,
      index: 0,
      pwds: {
        0: [],
        1: []
      }
    }
  },
  computed: {
    samePwds () {
      return JSON.stringify(this.pwds[0]) === JSON.stringify(this.pwds[1])
    }
  },
  methods: {
    onChange (numbers) {
      if (numbers.length < 5) {
        Toast(this.$t('手势密码至少需要位，请重新输入', { limit: 5 }))
      } else {
        this.pwds[this.index++] = numbers
      }
      if (this.index === 2) {
        // reset index if input diffirent pwd the second time
        if (!this.samePwds) this.index = 0
        // finish input if everything is fine
        else this.done()
      }
    },
    done () {
      Notify({
        type: 'success',
        message: this.$t('手势密码设置成功')
      })
      const password = this.$root.password
      const key = this.pwds[1]
      const encryptedPwdk = encrypt(key, password)
      ls.set(LS_KEYS.ENCRYPTED_PWD, encryptedPwdk)
      this.$router.push({ name: 'home' })
    },
    disableTips () {
      ls.set(LS_KEYS.NO_LOGNGER_SHOW_GESTURE_TIPS, true)
    }
  },
  mounted () {
    if (
      !this.$root.password ||
      ls.get(LS_KEYS.NO_LOGNGER_SHOW_GESTURE_TIPS) ||
      ls.get(LS_KEYS.ENCRYPTED_PWD)
    ) this.$router.push({ name: 'home' })
  }
}
</script>
